<template>
	<div class="content">
	   <div class="card">
	     <div class="card-content">
	       <div class="card-content-inner" style="text-align:center">多麼想見到你<br>那怕像路人一樣<br>只允許我看一眼就走</div>
	     </div>
	   </div>
	  
	    <div class="list-block">
	        <ul>
	            <li>
	                <div class="item-content">
	                    <div class="item-media"><i class="icon icon-form-name"></i></div>
	                    <div class="item-inner">
	                        <div class="item-title label">商品总数量</div>
	                        <div class="item-input">                          
								<input type="number" id="quantity" placeholder="请输入商品总数量" v-model="value1">
	                        </div>
	                    </div>
	                </div>
	            </li>
	
	            <li>
	                <div class="item-content">
	                    <div class="item-media"><i class="icon icon-form-name"></i></div>
	                    <div class="item-inner">
	                        <div class="item-title label">商品单价</div>
	                        <div class="item-input">
	                            <input type="number" id="price" placeholder="请输入商品单价" v-model="value2">
	                        </div>
	                    </div>
	                </div>
	            </li>
	
	            <li>
	                <div class="item-content">
	                    <div class="item-media"><i class="icon icon-form-name"></i></div>
	                    <div class="item-inner">
	                        <div class="item-title label">单张发票限额</div>
	                        <div class="item-input">
	                            <input type="number" id="maxInvoice" placeholder="留空默认为10000" v-model="value3">
	                        </div>
	                    </div>
	                </div>
	            </li>
	
	            <li>
	                <div class="item-content">
	                    <div class="item-media"><i class="icon icon-form-name"></i></div>
	                    <div class="item-inner">
	                        <div class="item-title label">单票数量倍数</div>
	                        <div class="item-input">
	                            <input type="number" id="multiple" placeholder="留空默认为25" v-model="value4">
	                        </div>
	                    </div>
	                </div>
	            </li>
	        </ul>
	    </div>
		
	    <div class="content-block" v-on:click="check()">
	        <div class="col-50"><a class="button button-big button-fill button-success">提交</a></div>
	    </div>
	</div>
</template>



<script>
	export default {
		name: 'home',
		data() {
			return {
				value1: "", // quantity
				value2: "", // price
				value3: "", // maxInvoice
				value4: "", // multiple	
				preset_value3: 10000, // 预设值
				preset_value4: 25,    // 预设值
				MAX_PER_INVOICE_CONTAIN : "", // 「理想单票商品数量」（不受倍数限制）
				TRUE_PER_INVOICE_CONTAIN: "", // 「实际单票商品数量」（受倍数限制）
				LESS_PER_INVOICE_CONTAIN: "", // 「剩余单票商品数量」
				BIG_NUM_INVOINCE: 0,	      // 「大数量发票数」
				SMALL_NUM_INVOINCE: 0,	      // 「小数量发票数」
			}			
		}, 
		methods:{
			check: function() {
				// 检查参数
				if (this.value3 != 0 ) {
					this.preset_value3 = this.value3;									  
				} 
				if (this.value4 != 0) {
					this.preset_value4 = this.value4;								  
				}
				
				if (this.value1 == 0) {
					$.toast("请输入商品总数量");
					return;
				}
				if (this.value2 == 0) {
					$.toast("请输入商品单价");
					return;
				}
				if (this.value1 * this.value2 <= this.preset_value3) {
					$.toast("总金额低于单张发票限额");
					return;
				}
				if (this.value1 % this.preset_value4 != 0) {
					$.toast("总数量不是" + this.preset_value4 + "的倍数");
					return;
				}
				
				// 参数无错误，执行计算
				this.count();
			},
			
			count:function(){
				// 设置默认参数			
				this.value3 = this.preset_value3;									  
				this.value4 = this.preset_value4;									  
						
				/**
				 ****************************** 核心算法 *****************************
				 **/  
				  				   
				// 用「单张发票限额」除以「商品单价」，可以得出「单张发票」最多可以承载的「理想单票商品数量」。
				this.MAX_PER_INVOICE_CONTAIN = Math.floor(this.value3 / this.value2);
				
				// 但是「理想单票商品数量」的「商品数量」必须受到「倍数」约束，所以从最大开始，看看哪个数是最大的「实际单票商品数量」
				for (this.MAX_PER_INVOICE_CONTAIN; this.MAX_PER_INVOICE_CONTAIN >= 0; this.MAX_PER_INVOICE_CONTAIN--) 
				{
					// 用「倍数」对「理想单票商品数量」取余。余数为0即满足。得到「实际单票商品数量」
					if (this.MAX_PER_INVOICE_CONTAIN % this.value4 == 0)
					{
						this.TRUE_PER_INVOICE_CONTAIN = this.MAX_PER_INVOICE_CONTAIN;
						break;
					}
				}
				  
				// 拿「商品总数量」除以「实际单票商品数量」，得出「实际单票商品数量」应该开多少张(「实际单票商品数量发票数」)
				this.BIG_NUM_INVOINCE   = Math.floor(this.value1 / this.TRUE_PER_INVOICE_CONTAIN);
				// 剩下的只能包含在一张内了
				this.SMALL_NUM_INVOINCE = 1;
							  
				// 算算剩下的数量额
				this.LESS_PER_INVOICE_CONTAIN = this.value1 - (this.BIG_NUM_INVOINCE * this.TRUE_PER_INVOICE_CONTAIN);
										
				/**
				 ****************************** 核心算法 *****************************
				 **/
				 
				// 传到结果页显示
				this.$router.push({
					name:'result',
					query:{
						'val1': this.BIG_NUM_INVOINCE,
						'val2': this.TRUE_PER_INVOICE_CONTAIN,
						'val3': this.TRUE_PER_INVOICE_CONTAIN * this.value2,
						'val4': this.SMALL_NUM_INVOINCE,
						'val5': this.LESS_PER_INVOICE_CONTAIN,
						'val6': this.LESS_PER_INVOICE_CONTAIN * this.value2
						},
				});
					 
				// 检验。。。		
				// alert(
				// 	this.BIG_NUM_INVOINCE + " " +
				// 	this.TRUE_PER_INVOICE_CONTAIN + " " +
				// 	this.TRUE_PER_INVOICE_CONTAIN*this.value2 + " " +
				// 	this.SMALL_NUM_INVOINCE + " " +
				// 	this.LESS_PER_INVOICE_CONTAIN + " " +
				// 	this.LESS_PER_INVOICE_CONTAIN*this.value2
				//    )																																													
			  }
		  }
	}
</script>

